import { useEffect } from 'react';
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}
const GTM_ID = 'GTM-MRFPC9JC';
const SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
export function GoogleTagManager() {
  useEffect(() => {
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = SRC;
    document.head.appendChild(script);
  }, []);
  return <noscript data-id="element-70" data-mp="2z1uh5h2eje4g">
      <iframe src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`} height="0" width="0" style={{
      display: 'none',
      visibility: 'hidden'
    }} title="Google Tag Manager" data-id="element-71" data-mp="2z3p2gwhl5892" />
    </noscript>;
}